import React, { memo, SVGProps } from 'react'

export const DotsVerticalSmall = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M10.6158 4C10.6158 4.76481 11.2352 5.3842 12 5.3842C12.7648 5.3842 13.3842 4.76481 13.3842 4C13.3842 3.23519 12.7648 2.6158 12 2.6158C11.2352 2.6158 10.6158 3.23519 10.6158 4Z"
      fill="currentColor"
    />
    <path
      d="M10.6158 12C10.6158 12.7648 11.2352 13.3842 12 13.3842C12.7648 13.3842 13.3842 12.7648 13.3842 12C13.3842 11.2352 12.7648 10.6158 12 10.6158C11.2352 10.6158 10.6158 11.2352 10.6158 12Z"
      fill="currentColor"
    />
    <path
      d="M10.6158 20C10.6158 20.7648 11.2352 21.3842 12 21.3842C12.7648 21.3842 13.3842 20.7648 13.3842 20C13.3842 19.2352 12.7648 18.6158 12 18.6158C11.2352 18.6158 10.6158 19.2352 10.6158 20Z"
      fill="currentColor"
    />
  </svg>
))
